export const products = [
  {
    id: 1,
    name: 'Платье "Золотая нить"',
    nameEn: 'Golden Thread Dress',
    nameEs: 'Vestido Hilo Dorado',
    price: 285000,
    category: 'fashion',
    collection: 'haute-couture',
    description: 'Шёлковое платье с ручной вышивкой золотыми нитями. Эксклюзивная работа мастеров с более чем 150 часами ручного труда.',
    descriptionEn: 'Silk dress with hand embroidery with gold threads. Exclusive work of masters with more than 150 hours of manual labor.',
    descriptionEs: 'Vestido de seda con bordado a mano con hilos de oro. Trabajo exclusivo de maestros con más de 150 horas de trabajo manual.',
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=600&h=800&fit=crop&q=80',
      'https://images.unsplash.com/photo-1566174053879-31528523f8ae?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['XS', 'S', 'M', 'L'],
    colors: ['Черный', 'Золотой'],
    inStock: true,
    badge: 'Эксклюзив'
  },
  {
    id: 2,
    name: 'Сумка "Императрица"',
    nameEn: 'Empress Bag',
    nameEs: 'Bolso Emperatriz',
    price: 450000,
    category: 'accessories',
    collection: 'limited',
    description: 'Эксклюзивная сумка из кожи крокодила с фурнитурой из золота 18 карат. Лимитированная серия.',
    descriptionEn: 'Exclusive crocodile leather bag with 18-karat gold hardware. Limited series.',
    descriptionEs: 'Bolso exclusivo de cuero de cocodrilo con herrajes de oro de 18 quilates. Serie limitada.',
    image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=600&h=800&fit=crop&q=80',
      'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['One Size'],
    colors: ['Черный', 'Коричневый'],
    inStock: true,
    badge: 'Лимитед'
  },
  {
    id: 3,
    name: 'Колье "Звёздная пыль"',
    nameEn: 'Stardust Necklace',
    nameEs: 'Collar Polvo Estelar',
    price: 1250000,
    category: 'jewelry',
    collection: 'exclusive',
    description: 'Колье из платины с бриллиантами общим весом 5 карат. Единственный экземпляр.',
    descriptionEn: 'Platinum necklace with diamonds totaling 5 carats. Single copy.',
    descriptionEs: 'Collar de platino con diamantes por un total de 5 quilates. Copia única.',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['One Size'],
    colors: ['Платина'],
    inStock: true,
    badge: 'Единственное'
  },
  {
    id: 4,
    name: 'Пальто "Королевский кашемир"',
    nameEn: 'Royal Cashmere Coat',
    nameEs: 'Abrigo Cachemira Real',
    price: 195000,
    category: 'fashion',
    collection: 'pret-a-porter',
    description: 'Пальто из 100% кашемира ручной работы. Классический крой с современными деталями.',
    descriptionEn: '100% handmade cashmere coat. Classic cut with modern details.',
    descriptionEs: 'Abrigo de cachemira 100% hecho a mano. Corte clásico con detalles modernos.',
    image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Бежевый', 'Черный', 'Серый'],
    inStock: true,
    badge: 'Кашемир'
  },
  {
    id: 5,
    name: 'Туфли "Элегантность"',
    nameEn: 'Elegance Shoes',
    nameEs: 'Zapatos Elegancia',
    price: 89000,
    category: 'accessories',
    collection: 'pret-a-porter',
    description: 'Туфли из итальянской кожи на каблуке 8 см. Идеальная посадка и комфорт.',
    descriptionEn: 'Shoes made of Italian leather with an 8 cm heel. Perfect fit and comfort.',
    descriptionEs: 'Zapatos de cuero italiano con tacón de 8 cm. Ajuste perfecto y comodidad.',
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['35', '36', '37', '38', '39', '40', '41'],
    colors: ['Черный', 'Бежевый', 'Красный'],
    inStock: true,
    badge: null
  },
  {
    id: 6,
    name: 'Аромат "Midnight Rose"',
    nameEn: 'Midnight Rose Fragrance',
    nameEs: 'Fragancia Rosa de Medianoche',
    price: 45000,
    category: 'fragrances',
    collection: 'signature',
    description: 'Чувственный аромат с нотами розы, мускуса и ванили. 100 мл.',
    descriptionEn: 'Sensual fragrance with notes of rose, musk and vanilla. 100 ml.',
    descriptionEs: 'Fragancia sensual con notas de rosa, almizcle y vainilla. 100 ml.',
    image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1541643600914-78b084683601?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['50ml', '100ml'],
    colors: [],
    inStock: true,
    badge: 'Новинка'
  },
  {
    id: 7,
    name: 'Серьги "Brilliance"',
    nameEn: 'Brilliance Earrings',
    nameEs: 'Pendientes Brillantez',
    price: 380000,
    category: 'jewelry',
    collection: 'signature',
    description: 'Серьги из белого золота с бриллиантами 2 карата.',
    descriptionEn: 'White gold earrings with 2 carat diamonds.',
    descriptionEs: 'Pendientes de oro blanco con diamantes de 2 quilates.',
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['One Size'],
    colors: ['Белое золото'],
    inStock: true,
    badge: null
  },
  {
    id: 8,
    name: 'Платье "Aurora"',
    nameEn: 'Aurora Dress',
    nameEs: 'Vestido Aurora',
    price: 165000,
    category: 'fashion',
    collection: 'spring',
    description: 'Легкое шифоновое платье с цветочным принтом. Идеально для весны.',
    descriptionEn: 'Light chiffon dress with floral print. Perfect for spring.',
    descriptionEs: 'Vestido ligero de gasa con estampado floral. Perfecto para la primavera.',
    image: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=600&h=800&fit=crop&q=80',
    images: [
      'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=600&h=800&fit=crop&q=80'
    ],
    sizes: ['XS', 'S', 'M', 'L'],
    colors: ['Розовый', 'Голубой', 'Белый'],
    inStock: true,
    badge: 'Новинка'
  }
]

export const categories = [
  { id: 'all', name: { ru: 'Все', en: 'All', es: 'Todo' } },
  { 
    id: 'dresses', 
    name: { ru: 'Платья', en: 'Dresses', es: 'Vestidos' },
    subcategories: [
      { id: 'Kids', name: { ru: 'Детские', en: 'Kids', es: 'Niños' } },
      { id: 'Woman', name: { ru: 'Женские', en: 'Woman', es: 'Mujer' } }
    ]
  }
]

export const collections = [
  { id: 'all', name: { ru: 'Все коллекции', en: 'All Collections', es: 'Todas las Colecciones' } }
]

